import React from 'react'
import { TabList } from '@hub/tabs'
import { HubStyleObject } from '@hub/design-system-base'
import { TabItemList } from './tab-list-item'
import { UniversalHeaderTabs } from '.'

export const HeaderTabs: React.FC<{
  tabsProps: React.ComponentProps<typeof UniversalHeaderTabs>
  sx: HubStyleObject
}> = ({ tabsProps, sx }) => {
  const nationalUrl = tabsProps.variant === 'centre' ? '/' : undefined

  return (
    <TabList sx={sx}>
      {tabsProps.variant === 'gift-cards' ? (
        <TabItemList
          tabName="Gift cards"
          selectedColour="brand"
          sx={{ display: 'none' }}
        />
      ) : (
        <>
          <TabItemList
            tabName="Shop online"
            selectedColour="vibrantTeal"
            url={nationalUrl}
          />
          <TabItemList
            tabName={tabsProps.centre?.title ?? 'Visit a centre'}
            selectedColour="brand"
          />
        </>
      )}
    </TabList>
  )
}
